import { createSlice } from '@reduxjs/toolkit'
import { getActiveFilters } from 'utils/helpers'

const initialState = {
  activeFilters: [] as string[],
  tableFilters: {
    search: '',
    type: '',
    status: '',
    tier: '',
    student: '',
  },
}

export const rtiInterventionsUI = createSlice({
  name: 'rtiInterventionsUI',
  initialState: initialState,
  reducers: {
    setSearch: (state, { payload }) => {
      state.tableFilters.search = payload
    },
    setType: (state, { payload }) => {
      state.tableFilters.type = payload
    },
    setStatus: (state, { payload }) => {
      state.tableFilters.status = payload
    },
    setTier: (state, { payload }) => {
      state.tableFilters.tier = payload
    },
    setStudent: (state, { payload }) => {
      state.tableFilters.student = payload
    },
    trackActiveFilters: (state: any) => {
      state.activeFilters = getActiveFilters(initialState.tableFilters, state)
    },
    clearAllFilters: (state: any) => {
      state.tableFilters = initialState.tableFilters
      state.activeFilters = []
    },
  },
})

export const {
  setSearch,
  setType,
  setStatus,
  setTier,
  setStudent,
  trackActiveFilters,
  clearAllFilters,
} = rtiInterventionsUI.actions

export default rtiInterventionsUI.reducer
